// FIXME: This file is just an example, please take it as reference to make your own.

import { combineReducers } from 'redux'

export default combineReducers({})
